export default "__VITE_ASSET__5AJiN1OT__"